import { sandboxBaseForApp } from './sandboxOverride'

export const isValidURL = (url) => {
  if (!url) return false
  try {
    // eslint-disable-next-line no-new
    new URL(url)
    return true
  } catch (error) {
    return false
  }
}

export const EMBED_URL_STRATEGIES = {
  'docs.google.com': (url) => url.replace('/pub?', '/embed?'),
  'youtube.com/watch': (url) => {
    const videoId = url.match(/[?&]v=([^&]+)/)?.[1]
    return videoId ? `https://www.youtube.com/embed/${videoId}` : url
  },
  'youtu.be': (url) => {
    const videoId = url.match(/youtu\.be\/([^?]+)/)?.[1]
    return videoId ? `https://www.youtube.com/embed/${videoId}` : url
  },
  'vimeo.com': (url) => {
    const videoId = url.match(/vimeo\.com\/(?:video\/)?([^?&#]+)/)?.[1]
    return videoId ? `https://player.vimeo.com/video/${videoId}` : url
  },
  'miro.com/app/board/': (url) => {
    const boardId = url.match(/board\/([^?&#]+)/)?.[1]
    return boardId ? `https://miro.com/app/embed/${boardId}` : url
  },
  'skoletube.dk/video/': (url) => {
    const videoId = url.match(/video\/[^/]+\/([^/]+)/)?.[1]
    return videoId ? `https://skoletube.dk/e/${videoId}` : url
  },
}

export const getParamValue = (param, url) => {
  if (!url) url = window.location.href
  param = param.replace(/[\\[\]]/g, '\\$&')
  const regex = new RegExp(`[?&]${param}(=([^&#]*)|&|#|$)`)
  const results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export const resolveSameOriginBase = (url) => {
  if (!url || typeof window === 'undefined') return url
  const { origin } = window.location
  let path = null
  if (url.startsWith('/')) {
    path = url
  } else if (url === origin || url.startsWith(`${origin}/`)) {
    path = url.slice(origin.length) || '/'
  }
  if (path !== null) {
    const sandboxBase = sandboxBaseForApp(path.split('/')[1])
    if (sandboxBase) return origin + sandboxBase
  }
  return url.startsWith('/') ? origin + url : url
}
